// Import service images
import haircutImg from '../assets/services/haircut.jpg';
import straightRazorImg from '../assets/services/straight_razor_shave.png';
import haircutShaveImg from '../assets/services/haircut_and_shave.jpg';
import buzzCutImg from '../assets/services/buzz_cut.jpg';
import beardTrimImg from '../assets/services/beard_trim.jpg';
import seniorCutImg from '../assets/services/senior_haircut.webp';
import kidsCutImg from '../assets/services/kid_cut.jpeg';
import smpImg from '../assets/smp.webp';

export interface Service {
  name: string;
  price: string;
  image: string;
  description: string;
  isSpecial?: boolean;
  linkTo?: string;
}

export const services: Service[] = [
  {
    name: "HAIRCUTS",
    price: "$60",
    image: haircutImg,
    description: "Tapers, fades, pompadours, sideparts, classic cuts, crew cuts, etc.. we do it all. If you can't explain it just bring in a picture. Be advised, we can give you Brad Pitt's haircut but we can't actually make you Brad Pitt. All cuts include straight razor neck shave and hot towel treatment."
  },
  {
    name: "STRAIGHT RAZOR SHAVES",
    price: "$50",
    image: straightRazorImg,
    description: "The service that every man should experience in his life time. Traditional shave with single bladed straight razor. Metropolitan straight razor shaves consist of the use of pre-shave oils, hot lather and hot towel treatments."
  },
  {
    name: "HAIRCUT & SHAVE",
    price: "$110",
    image: haircutShaveImg,
    description: "C'mon.. Treat ya'self. you know you want to"
  },
  {
    name: "SCALP MICRO PIGMENTATION",
    price: "Starting at $1,200",
    image: smpImg,
    description: "Revolutionary non-surgical hair restoration treatment that creates the appearance of fuller, thicker hair. Perfect for male pattern baldness, thinning hair, or enhancing existing hairlines.",
    isSpecial: true,
    linkTo: "/smp"
  },
  {
    name: "BUZZ CUTS",
    price: "$25",
    image: buzzCutImg,
    description: "Designated for the simple man. Get up and go! All buzz cuts consist of one clipper length all around with round or square neckline. All cuts include straight razor neck shave and hot towel treatment."
  },
  {
    name: "BEARD TRIM",
    price: "$30",
    image: beardTrimImg,
    description: "For those whose beards need a little lovin'. Beard trims consist of shaping, trimming, and lining of the beard. Includes electric shaver on neck and razor line on cheek depending on the barber."
  },
  {
    name: "SENIOR CUTS",
    price: "$35",
    image: seniorCutImg,
    description: "Ages 65+"
  },
  {
    name: "KIDS CUTS",
    price: "$40",
    image: kidsCutImg,
    description: "Ages 12 & under. Little guys need love too craig"
  }
]; 